module.exports = __webpack_public_path__ + "static/img/展示图.f8d7aadc.png";